/*
    Core store module actions
*/

import * as vuexyComponentActions from "./vuexy-components-actions";
import * as vuexyUIActions from "./vuexy-ui-actions";
import * as data from "./data";
import * as server from "./server";
import * as temp from "./temp";

export default {
  ...vuexyComponentActions,
  ...vuexyUIActions,
  ...data,
  ...server,
  ...temp,
}
